<template>
  <div>
    <div class="container-fluid" style="zoom: 80%">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h3 style="font-weight:700">Account Settings</h3>
        </div>
        <Sidebar />
        <div class="col-md-10 pl-0" v-if="status">
          <div class="card card-box mb-3 " style="border-radius : 0%">
            <div class="card-body">
              <b-form>
                <div class="row">
                  <div class="col-md-12 mt-2 mb-3">
                    <h4 class="__blue" style="font-weight: 700">
                      Informasi Umum
                    </h4>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1" label="Nama Klinik">
                      <b-form-input
                        id="input-1"
                        v-model="formDataKlinik[0].nama_klinik"
                        disabled
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for="">Lokasi Klinik</label>
                      <b-form-input
                        disabled
                        v-model="formDataKlinik[1].lokasi"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for="">Nama Dokter</label>
                      <b-form-input
                        disabled
                        v-model="formDataKlinik[2].nama_dokter"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for="">Email</label>
                      <b-form-input
                        disabled
                        v-model="formDataKlinik[3].email"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for="">No. Handphone</label>
                      <b-form-input
                        disabled
                        v-model="formDataKlinik[4].nomor_telp"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1">
                      <label for="">Spesialisasi</label>
                      <b-form-input
                        disabled
                        v-model="formDataKlinik[5].spesialisasi"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group style="position: relative">
                      <label for=""
                        >Masa berlaku SIP<span style="color:red">*</span>
                      </label>
                      <DatePickerX
                        :masks="{ input: 'DD-MM-YYYY' }"
                        v-model="formDataKlinik[7].masa_berlaku_sip"
                        @input="tglSelected(formDataKlinik[4].masa_berlaku_sip)"
                      >
                        <template v-slot="{ inputValue, inputEvents }">
                          <b-form-input
                            :value="inputValue"
                            v-on="inputEvents"
                            :readonly="true"
                            :disabled="!btnDisable"
                            :style="
                              !btnDisable
                                ? 'background-color:#eeeff8;'
                                : 'background-color:#ffffff;'
                            "
                          ></b-form-input>
                        </template>
                      </DatePickerX>
                      <font-awesome-icon
                        icon="calendar"
                        style="
                                    float: right !important;
                                    position: absolute;
                                    right: 15px;
                                    top: 43px;
                                    color: gray;
                                    "
                      />
                      <span
                        style="color:red"
                        v-if="
                          formDataKlinik[7].desc != null ||
                            formDataKlinik[7].desc != ''
                        "
                      >
                        {{ formDataKlinik[7].desc }}
                      </span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group>
                      <label for=""
                        >No. SIP<span style="color:red">*</span>
                      </label>
                      <b-form-input
                        id="input-1"
                        v-model="formDataKlinik[6].nomor_sip"
                        maxlength="50"
                        @input="cekValue(formDataKlinik[6].nomor_sip)"
                        :disabled="!btnDisable"
                        @keyup="
                          onChangeValue(
                            formDataKlinik[6].nomor_sip,
                            '6',
                            'nomor_sip'
                          )
                        "
                      ></b-form-input>
                      <span
                        style="color:red"
                        v-if="
                          formDataKlinik[6].desc != null ||
                            formDataKlinik[6].desc != ''
                        "
                      >
                        {{ formDataKlinik[6].desc }}
                      </span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="input-group-1" label="Upload SIP">
                      <div
                        id="upload-box"
                        class="row justify-content-md-center"
                      >
                        <b-button
                          variant="dark"
                          @click="!btnDisable ? '#' : $refs.fileInput.click()"
                        >
                          <span class="btn-wrapper--icon">
                            <font-awesome-icon icon="folder" />
                          </span>
                          <span class="btn-wrapper--label">Cari File</span>
                        </b-button>
                        <input
                          type="file"
                          accept="image/*,.pdf"
                          @change="onFileSelected"
                          @click="resetFileInput"
                          style="display:none"
                          ref="fileInput"
                          multiple="multiple"
                        />
                      </div>
                    </b-form-group>
                    <br />
                    <small class="mt-3"
                      ><i
                        >* format yang diizinkan: jpeg, jpg, png, pdf, maks 2
                        MB.</i
                      ></small
                    >
                    <br />
                    <div
                      v-for="(item, index) in selectedFiles"
                      :key="item.index"
                      class="row file-upload"
                    >
                      <div class="col-md-4">
                        <label class="text-break">{{ item.name }}</label>
                      </div>
                      <div class="col-md-2">
                        <label>{{ item.size / 1000 }} KB</label>
                      </div>
                      <div class="col-md-3">
                        <b-progress :max="100">
                          <b-progress-bar
                            :value="fileProgress[item.name]"
                            :label="`${Math.round(fileProgress[item.name])}%`"
                          ></b-progress-bar>
                        </b-progress>
                      </div>
                      <div class="col-md-3">
                        <div class="row d-flex justify-content-end mr-2">
                          <!-- :href="item.url" -->
                          <a
                            @click.prevent="donwloadImage(item)"
                            v-if="item.from_api"
                          >
                            <font-awesome-icon
                              icon="download"
                              class="font-size-xl grow icon"
                              style="margin-right:20px"
                            />
                          </a>
                          <a v-else @click="downloadFile(item)">
                            <font-awesome-icon
                              icon="download"
                              class="font-size-xl grow icon"
                              style="margin-right:20px"
                            />
                          </a>
                          <font-awesome-icon
                            icon="eye"
                            class="font-size-xl grow icon"
                            style="margin-right:20px"
                            v-if="isShow(item)"
                            @click="readFile(item)"
                          />
                          <template v-if="!btnDisable">
                            <font-awesome-icon
                              icon="trash"
                              class="font-size-xl grow icon"
                            />
                          </template>
                          <template v-else>
                            <font-awesome-icon
                              icon="trash"
                              style="cursor:pointer"
                              class="font-size-xl grow icon"
                              @click="removeFile(item, index)"
                            />
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mt-3 mb-3">
                    <b-button
                      variant="primary"
                      v-if="btnDisable"
                      class="float-right"
                      @click="onSubmit"
                      >SIMPAN DATA</b-button
                    >
                    <b-button
                      variant="primary"
                      v-if="!btnDisable"
                      @click="btnDisable = true"
                      class="float-right"
                      >EDIT DATA</b-button
                    >
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import startCase from "lodash/startCase";
import moment from "moment";
import { mapGetters } from "vuex";
moment.locale("id");
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faFolder,
  faCamera,
  faCalendar,
  faDownload,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
library.add(faInfo, faCamera, faFolder, faCalendar, faDownload, faTrash);
import debounce from "lodash/debounce";

import { ImageCompressor } from "compressor-img";

export default {
  components: {
    Sidebar: () => import("@/views/AccountSettingKlinik/Sidebar"),
    DatePickerX: () => import("v-calendar/lib/components/date-picker.umd")
  },
  data: () => {
    return {
      formDataKlinik: [],
      status: false,

      imageProps: {
        width: 75,
        height: 75
      },
      btnDisable: false,

      selectedFiles: [],
      fileReaderPromises: [],
      uploadedFiles: [],
      fileProgress: [],
      promises: [],
      foto_profile: null,
      supportedFiles: ["png", "jpg", "jpeg", "pdf"]
    };
  },
  mounted() {
    this.getProfile();
    this.cekPaketNolock();

    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  watch: {
    dataProfile: {
      handler: function(val) {
        if (val) {
          this.fetchImg();
        }
      },
      deep: true
    }
  },
  methods: {
    isShow(d) {
      if (d.name != undefined) {
        const accept = ["jpeg", "jpg", "png", "JPEG", "JPG", "PNG", "pdf"];
        let ext =
          d.uploaded_name != null
            ? d.uploaded_name.split(".").pop()
            : d.name.split(".").pop();
        if (accept.includes(ext)) return true;
        else return false;
      } else {
        return false;
      }
    },
    //convert b64 to blob
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    //compress if file images
    compressImage(file) {
      this.fileReaderPromises.push(
        new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onloadend = () => {
            let imageCompressor = new ImageCompressor({
              onSuccess: response => {
                let ImageURL = response.compressed;
                let block = ImageURL.split(";");
                let contentType = block[0].split(":")[1];
                let realData = block[1].split(",")[1];
                let blob = this.b64toBlob(realData, contentType);
                resolve({ name: file.name, file: blob, size: blob.size });
              },
              scale: 70,
              quality: 70,
              originalImage: reader.result
            });
          };
          reader.readAsDataURL(file);
        })
      );
    },
    //prepare formData
    prepareUpload(filename, file) {
      let formData = new FormData();
      formData.append("klinik_id", this.getKlinikId);
      formData.append("file", file);
      formData.append("filename", filename);
      formData.append("type", "dokter");

      var profile = this.$store.state.dokterId;

      this.promises.push(
        this.$axios
          .post(`klinik/upload/sip/${profile}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              let progress = (progressEvent.loaded * 100) / progressEvent.total;
              this.$set(this.fileProgress, filename, progress);
            }
          })
          .then(res => {
            if (res.data.status) this.uploadedFiles.push(res.data);
          })
          .catch(e => {
            this.$swal({
              type: "warning",
              text: `Format file melebihi ukuran 1 MB!`
            }).then(() => {
              let rmIndex = this.selectedFiles
                .map(item => {
                  return item.name;
                })
                .indexOf(filename);
              this.selectedFiles.splice(rmIndex, 1);
            });
          })
      );
    },
    isFileImage(file) {
      const acceptedImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "pdf"
      ];
      return file && acceptedImageTypes.includes(file["type"]);
    },
    async onFileSelected(event) {
      const {
        target: { files }
      } = event;
      this.fileReaderPromises = [];

      if (
        this.selectedFiles.some(x =>
          Object.keys(files)
            .filter(item => item !== "length")
            .some(item => files[item].name === x.name)
        )
      ) {
        this.$swal({
          type: "error",
          text: "Anda tidak bisa memasukkan data yang sama!"
        });
        return false;
      }

      var a = document.getElementsByClassName("file-upload");
      if (a.length + event.target.files.length > 1) {
        this.$swal({
          type: "warning",
          text: "Upload maksimal 1 File!"
        });
        return;
      }

      for (let i = 0; i < event.target.files.length; i++) {
        if (i == 1 || this.selectedFiles.length == 1) {
          this.$swal({
            type: "warning",
            text: "Upload maksimal 1 File!"
          });
          return;
        }
        let file = event.target.files[i];
        let extension = file.name.split(".").pop();

        if (this.supportedFiles.includes(extension.toLowerCase())) {
          if (this.isFileImage(file)) {
            this.compressImage(file);
          } else {
            file = {
              name: file.name,
              file: file,
              size: file.size,
              from_api: false
            };
            this.selectedFiles.push(file);
          }
        } else {
          this.$swal({
            type: "warning",
            text: "Format file salah! Hanya dapat format JPG, JPEG, PDF, PNG!"
            // Format file melebihi ukuran 1 MB!
          });
        }
      }

      await Promise.all(this.fileReaderPromises)
        .then(res => {
          res.map(item => {
            this.selectedFiles.push(item);
          });
        })
        .then(this.processUpload);
    },
    async processUpload() {
      if (this.selectedFiles.length > 0) {
        this.selectedFiles.map(item => {
          if (!item.isUploading && !item.from_api) {
            this.prepareUpload(item.name, item.file);
            item.isUploading = true;
          }
        });
      }

      try {
        await Promise.all(this.promises).then(res => {
          res.map((item, index) => {
            if (!item.data.status) {
              return this.$swal({
                type: "error",
                title: "Oops...",
                text: item.data.message
              }).then(() => {});
            } else {
              this.uploadedFiles = res.reduce((unique, item) => {
                return unique.includes(item.data)
                  ? unique
                  : [...unique, item.data];
              }, []);
            }
          });
        });
      } catch (e) {
        // console.log(e)
      }

      if (this.selectedFiles.length > 0) {
        this.selectedFiles.map(item => {
          if (item.from_api) {
            this.uploadedFiles.push(item);
          }
        });
      }
    },
    async donwloadImage(item) {
      const a = document.createElement("a");
      a.href = await this.toDataURL(item.url);
      a.download = item.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    toDataURL(url) {
      return fetch(url)
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          return URL.createObjectURL(blob);
        });
    },
    //download selected file
    downloadFile(item) {
      if (item.from_api == true) {
        window.open(item.url || item.file, "_blank");
      } else {
        const data = window.URL.createObjectURL(item.file);
        const link = document.createElement("a");
        link.href = data;
        link.download = item.name;
        link.click();
        setTimeout(function() {
          window.URL.revokeObjectURL(data);
        }, 100);
      }
    },
    //view selected file
    readFile(item) {
      if (item.from_api == true) {
        window.open(item.file);
      } else {
        const data = window.URL.createObjectURL(item.file);
        window.open(data);
      }
    },
    //remove selected file
    removeFile(file, index) {
      var profile = this.$store.state.dokterId;

      this.selectedFiles.splice(index, 1);
      this.promises.splice(index, 1);

      let filename = file.name;
      filename = filename.split(" ").join("_");
      filename = filename.split(".").join("_");

      this.$axios.post(`klinik/delete-sip/${profile}`, {
        type: "dokter"
      });

      let removeIndex = this.uploadedFiles
        .map(item => {
          return item.name;
        })
        .indexOf(filename);

      this.uploadedFiles.splice(removeIndex, 1);
    },
    resetFileInput() {
      const x = this.$refs.fileInput;
      x.value = "";
    },
    cekValue: debounce(function(val) {
      this.$axios
        .post(`klinik/dokter/sip/cek`, {
          sip: val,
          klinik_id: this.getKlinikId
        })
        .then(res => {
          if (res.data.status) {
            this.formDataKlinik[6].error = false;
            this.formDataKlinik[6].desc = null;
          } else if (!res.data.status) {
            this.formDataKlinik[6].error = true;
            this.formDataKlinik[6].desc = "SIP telah terdaftar";
          }
        });
    }, 500),
    onSubmit() {
      let error = false;

      if (
        this.formDataKlinik[7].masa_berlaku_sip == null ||
        this.formDataKlinik[7].error
      ) {
        error = true;
        this.$swal({
          text: `Silakan lengkapi seluruh kolom!`,
          type: "warning",
          confirmButtonText: startCase("ya")
        });
      } else {
        error = false;
      }

      if (
        this.formDataKlinik[6].nomor_sip == null ||
        this.formDataKlinik[6].error
      ) {
        error = true;
        this.$swal({
          text: `Silakan lengkapi seluruh kolom!`,
          type: "warning",
          confirmButtonText: startCase("ya")
        });
      } else {
        error = false;
      }

      if (!error) {
        this.updateProses();
      }
    },
    tglSelected(data) {
      if (data != null) {
        this.formDataKlinik[7].desc = "";
        this.formDataKlinik[7].error = false;
      }
    },
    onChangeValue(data, index, label) {
      if (data == null || data.length == 0 || data == "") {
        this.formDataKlinik[index].desc = "Kolom harus diisi";
        this.formDataKlinik[index].error = true;
      } else {
        this.formDataKlinik[index].error = false;
        this.formDataKlinik[index].desc = null;
      }
    },
    fetchImg() {
      fetch(this.dataProfile.foto_profile)
        .then(response => response.blob())
        .then(images => {
          const x = URL.createObjectURL(images);
          this.prefillImage = x;
        });
    },
    async getProfile() {
      try {
        var profile = this.$store.state.user.id;

        const res = await this.$axios.get(
          `klinik/dokter/${profile}?klinik_id=${this.getKlinikId}&profile=true`
        );

        const { data } = res.data;

        this.foto_profile = data.foto_dokter;

        if (data.nomor_sip_file != null) {
          this.$set(this.fileProgress, data.nomor_sip_file.name, 100);
          this.selectedFiles.push({
            name: data.nomor_sip_file.name,
            size: data.nomor_sip_file.size,
            file: data.nomor_sip_file.url,
            url: data.nomor_sip_file.url,
            from_api: true,
            uploaded_name: data.nomor_sip_file.upload_name
          });
        }

        this.formDataKlinik = [
          //0
          {
            nama_klinik: data.klinik,
            error: null
          },
          //1
          {
            lokasi: data.kota,
            error: null
          },
          //2
          {
            nama_dokter: data.nama,
            error: null
          },
          //3
          {
            email: data.email,
            error: null
          },
          //4
          {
            nomor_telp: data.nomor_telp,
            error: null
          },
          //5
          {
            spesialisasi: data.spesialisasi_id,
            error: null
          },
          //6
          {
            nomor_sip: data.nomor_sip,
            error: null,
            desc: null
          },
          //7
          {
            masa_berlaku_sip: data.masa_berlaku_sip,
            error: null,
            desc: null
          },
          //8
          {
            nomor_sip_file: data.nomor_sip_file,
            error: null,
            desc: null
          }
        ];

        this.status = true;
      } catch (e) {}
    },
    async updateProses() {
      try {
        var profile = this.$store.state.user.id;
        const res = await this.$axios.put(`klinik/dokter`, {
          id: profile, //user id
          klinik_id: this.getKlinikId,
          profile: true, //khusus dihalaman accounts settings
          nomor_sip: this.formDataKlinik[6].nomor_sip,
          masa_berlaku_sip: this.formDataKlinik[7].masa_berlaku_sip
        });

        if (res.data.status) {
          this.$swal({
            type: "success",
            title: startCase("Simpan Profil"),
            text: startCase("Simpan Profil berhasil.")
          });
          this.btnDisable = false;
        } else {
          this.$swal({
            text: `Silakan lengkapi seluruh kolom!`,
            type: "warning",
            confirmButtonText: startCase("ya")
          });
        }
      } catch {}
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.picture-inner {
  top: -120px !important;
}
</style>

<style scoped>
.__blue {
  color: #4b80b6;
}

._outer_klinik_profile {
  /* outline-style: auto; */
  cursor: pointer;
}

.__outer_line_profile {
  border-right: rgb(121, 121, 121);
  border-left: none;
  border-top: none;
  border-bottom: none;
  /* position: absolute; */
  border-right-style: solid;
}

.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: 15px;
  z-index: 10;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.badge-alert {
  background-color: #ffffff;
  border: solid 1px rgba(7, 9, 25, 0.5) !important;
  border-radius: 50%;
  cursor: pointer;
}
</style>
